export enum StudentEksportPaczkaStatus {
  WTrakcie = 1,
  Zakonczony = 2,
}
